import React, { useEffect, useRef } from 'react';
import { Chart } from '@astrodraw/astrochart';
import { astroElements } from '../../static/astro';

export function AstroChartComponent({ horoscope, size = 400 }) {
  const chartId = 'astrochart-paper';
  const chartRef = useRef(null);

  useEffect(() => {
    if (!horoscope) return;

    // Prepare planets data exactly like the demo
    const chartPlanets = Object.assign(
      {},
      ...horoscope.CelestialBodies.all.map((body) => {
        const key = body.key.charAt(0).toUpperCase() + body.key.slice(1);
        return { [key]: [body.ChartPosition.Ecliptic.DecimalDegrees] };
      })
    );

    // Prepare house cusps exactly like the demo
    const chartCusps = horoscope.Houses.map((cusp) => {
      return cusp.ChartPosition.StartPosition.Ecliptic.DecimalDegrees;
    });

    // Remove previous chart SVG if any
    if (chartRef.current) {
      chartRef.current.innerHTML = '';
    }

    const settings = {
      COLORS_SIGNS: [
        astroElements.fire, 
        astroElements.earth, 
        astroElements.air, 
        astroElements.water, 
        astroElements.fire, 
        astroElements.earth, 
        astroElements.air, 
        astroElements.water, 
        astroElements.fire, 
        astroElements.earth, 
        astroElements.air, 
        astroElements.water, 
      ]
    };

    // Create and draw the chart
    const chart = new Chart(chartId, size, size, settings); 
    const data = {
      planets: chartPlanets,
      cusps: chartCusps,
    };

    const radix = chart.radix(data);
    
    // Add points of interest like the demo
    const asc = horoscope.Ascendant.ChartPosition.Horizon.DecimalDegrees;
    const desc = (asc + 180) % 360;
    const mc = horoscope.Midheaven.ChartPosition.Horizon.DecimalDegrees;
    const ic = (horoscope.Midheaven.ChartPosition.Horizon.DecimalDegrees + 180) % 360;
    
    const nn = horoscope?.CelestialPoints?.all?.find(p => p?.key === 'northnode')?.ChartPosition?.Ecliptic?.DecimalDegrees;
    // const mn = horoscope?.CelestialPoints?.all?.find(p => p?.key === 'meannode')?.ChartPosition?.Ecliptic?.DecimalDegrees; // mean node (commented)
    if (typeof nn === 'number') {
      radix.addPointsOfInterest({ As: [asc], Mc: [mc], Ds: [desc], Ic: [ic], Nn: [nn] });
    } else {
      radix.addPointsOfInterest({ As: [asc], Mc: [mc], Ds: [desc], Ic: [ic] });
    }
    radix.aspects();
  }, [horoscope]);

  return <div id={chartId} ref={chartRef}></div>;
} 